import { Component, OnInit, signal, WritableSignal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LocalAuthService } from "./local-auth.service";
import { ExternalToken } from "./tokens";


@Component({
    selector: 'app-external-auth-base',
    template: ``,
    styles: [],
    standalone: false
})
export abstract class ExternalAuthBaseComponent implements OnInit {

    protected externalToken: WritableSignal<ExternalToken | undefined> = signal(undefined)
    protected tokenExpired: WritableSignal<boolean> = signal(false);

    constructor(
        protected route: ActivatedRoute,
        protected authService: LocalAuthService
    ) {

    }

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            const token = params.get("externalToken");

            if (token) {
                this.authService.setExternalToken(token)
                const externalToken = (this.authService.parseExternalToken(token))
                this.externalToken.set(externalToken)
                this.tokenExpired.set(externalToken ? externalToken.exp < new Date() : false)
                this.onExternalTokenSet();


            }
        })

    }

    abstract onExternalTokenSet(): void;

}